import { ApiClient } from '@/lib/apiClient';
import type { CreateOutboundSustainabilityData, OutboundSustainabilityData } from '@/types/outboundSustainabilityData';

export default class OutboundSustainabilityDataService extends ApiClient<OutboundSustainabilityData, CreateOutboundSustainabilityData> {

  constructor() {
    super('/v1/outboundsustainabilitydata', 'id');
    
  }

  async deleteByMassBalanceid(id: number): Promise<void> {
    try {
      await this.apiClient.delete(`/massbalance/${id}`)
    } catch (error) {
      throw error
    }
  }
}
